module.exports = "https://coursera_assets.s3.amazonaws.com/images/e771552107b37faa2e463cdae094d970.png";